module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_04@2x-78bb6a0ab77fa5e0ae16bc496071a048.webp";